import { deleteFinding as deleteFindingDiagram, rebuildPVDiagram} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { updateGauges } from '@process-advisor/process-miner/api/methods/slicers/updateGauges';

export type DeleteFindingProps = ApiMethodBase & {
    findingID: string,
};

export async function deleteFinding ({ findingID, eventEmitter }: DeleteFindingProps) {
    deleteFindingDiagram(findingID);
    updateGauges({ eventEmitter });   
    eventEmitter.emit(Event.setActionBar_FindingsSummary);
    eventEmitter.emit(Event.setActionBar_FindingsVisualizer);

};

